import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import styled from "styled-components";

const StyledMenuItem = styled(MenuItem)`
    font-size: 12px;
`;

const EnvironmentSelect = ({
    fields,
    envField,
    projectsToSetup,
    setProjectsToSetup,
    projectName,
}) => {
    if (!fields || !fields.length) return null;
    const [selectedField, setSelectedField] = React.useState(envField?.jiraName || "");

    const handleChange = (event) => {
        const newFieldName = event.target.value;
        setSelectedField(newFieldName);
        const selectedFieldObj = fields.find((field) => field.name === newFieldName);
        const updatedProjects = projectsToSetup.map((project) => {
            if (project.name === projectName) {
                if (selectedFieldObj) {
                    return {
                        ...project,
                        fields: {
                            id: selectedFieldObj.id,
                            name: selectedFieldObj.name,
                            adadotName: "bugs_env",
                        },
                    };
                }
            }
            return project;
        });
        setProjectsToSetup(updatedProjects);
    };

    return (
        <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
            <InputLabel id="demo-select-small-label" sx={{ fontSize: 12 }}>
                Environment field for bugs
            </InputLabel>
            <Select
                labelId="custom-field"
                id="environment"
                value={selectedField}
                label="Environment field for bugs"
                sx={{ fontSize: 12 }}
                onChange={handleChange}
            >
                {fields.map((field) => {
                    return <StyledMenuItem value={field.name}>{field.name}</StyledMenuItem>;
                })}
            </Select>
        </FormControl>
    );
};

export default EnvironmentSelect;
